exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-header[data-v-09bde7e2]{display:flex;flex-direction:row;align-items:center;padding-top:8px;border-bottom:1px solid #aaa}.chat-header .back-button-group[data-v-09bde7e2]{width:33%}.chat-header .back-button-group .back-button[data-v-09bde7e2]{padding-left:16px;color:#aaa}.chat-header .avatar-group[data-v-09bde7e2]{width:33%;text-align:center}.chat-header .avatar-group .b-avatar[data-v-09bde7e2]{width:40px}.chat-header .end-group[data-v-09bde7e2]{width:33%}", ""]);

// exports
